import React from 'react';

function DaysWeek(props) {

  const res = (props._data) ? props._data.filter((el) => el.id < 0) : 0;

  const GridData = (props) =>
    props._data.days.map((it, index) => <div className="name_day_w common_w" key={index}>{it}</div>);


  return (
    <>
      {
        ((res) ?
          res.map((item, index) =>
            <div className="rec_calendar_w" key={index}>
              <div className="num_room_w common_w">
                &nbsp;&nbsp;&nbsp;
              </div>
              <GridData _data={item}/>
            </div>
          )
          :
          <></>)
      }
    </>
  );
}

export default DaysWeek;
